import { view, layout } from "@/mega-ui/helpers/function"

export const maintenance = {
    path: '/maintenance',
    name: 'maintenance',
    component: () => layout('EmptyLayout'),
    children: [
        {
            path: '',
            name: 'maintenance-main',
            component: () => view('errors/MaintenanceView')
        }
    ]
}